import { FC } from "react";

import { IconView } from "@/components/_molecules/icon-picker/icon-view";

export interface PhaseIconProps {
  phase?:
    | {
        color: string;
        icon?: string | null;
        iconType?: string | null;
      }
    | null
    | undefined;
  className?: string;
}

export const PhaseIcon: FC<PhaseIconProps> = ({ phase, className }) => {
  return <IconView icon={phase?.icon} iconType={phase?.iconType} color={phase?.color} className={className} />;
};
